import PropTypes from 'prop-types'
import Skeleton from 'react-loading-skeleton'
import { Heading } from '../../../../components/ui/Heading'

export default function InterviewRecommendation({
  interviews_label,
  interviews = [],
  isLoading
}) {
  return (
    <div className='rounded-lg border border-lightGrey bg-lightPaleGrey'>
      <div className='px-10 py-6'>
        <Heading className={'text-buttonSecondaryBlue'} level={4}>
          {isLoading ? <Skeleton width={200} /> : interviews_label}
        </Heading>
      </div>
      <div className='flex flex-col gap-y-4 border-t border-lightGrey p-6'>
        {isLoading && <Skeleton count={3} />}
        {Array.isArray(interviews) &&
          interviews?.map((interviewText, index) => (
            <div
              key={`${index}-${interviewText}`}
              className='flex flex-row items-center'
            >
              <svg
                width='14'
                height='13'
                viewBox='0 0 14 13'
                fill='none'
                className='mr-2 flex-shrink-0'
              >
                <path
                  d='M0 7.3486C0 8.34877 0.738474 9.20017 1.73405 9.29593C1.82262 9.30445 1.91127 9.31271 2 9.3207V11.75C2 12.0533 2.18273 12.3268 2.46299 12.4429C2.74324 12.559 3.06583 12.4948 3.28033 12.2803L5.10018 10.4605C4.72131 9.90116 4.5 9.22642 4.5 8.49998V7.49998C4.5 5.56699 6.067 3.99998 8 3.99998H12V2.65147C12 1.65131 11.2615 0.799919 10.266 0.704137C8.86223 0.569081 7.43918 0.499985 6 0.499985C4.56082 0.499985 3.13777 0.569081 1.734 0.704137C0.73845 0.799919 0 1.65131 0 2.65147V7.3486Z'
                  fill='#4461D4'
                />
                <path
                  d='M6 7.49998C6 6.39542 6.89543 5.49998 8 5.49998H12C13.1046 5.49998 14 6.39542 14 7.49998V8.49998C14 9.60455 13.1046 10.5 12 10.5H11.75V11.75C11.75 12.0533 11.5673 12.3268 11.287 12.4429C11.0068 12.559 10.6842 12.4948 10.4697 12.2803L8.68934 10.5H8C6.89543 10.5 6 9.60455 6 8.49998V7.49998Z'
                  fill='#4461D4'
                />
              </svg>
              <p className='text-base font-normal text-darkBlack'>
                {interviewText}
              </p>
            </div>
          ))}
      </div>
    </div>
  )
}

InterviewRecommendation.propTypes = {
  interviews_label: PropTypes.string.isRequired,
  interviews: PropTypes.arrayOf(PropTypes.string).isRequired
}
